module.exports = __webpack_public_path__ + "img/downloadapp.69d74c3b.jpg";